// Who may open each page of the admin area (and the two internal pages the
// admin home links to): ADMINS AND DEVELOPERS ONLY, every one of them (Angel,
// 2026-10-19: accounts, users, roles, permissions and everything else under
// the Admin tab are admins'). Whatever the Role Permissions grid gives a role,
// it never opens one of these; the API refuses their actions to everyone else
// too (graph/schema_gates_test.go, TestOnlyTheAdminTabIsGatedByRole).
//
// One table, read by the routes, the nav's Admin entry, the admin home's cards
// and the How To, so they cannot disagree: a card for a page its viewer cannot
// open, or an Admin entry leading to an empty page, is what a second copy would
// drift into.
export const ADMIN_PAGES = {
  'admin-users': { admin: true },
  'admin-user-detail': { admin: true },
  'location-users': { admin: true },
  'location-list': { admin: true },
  'admin-devices': { admin: true },
  'study-renewals': { admin: true },
  'import-arc-flash': { admin: true },
  'import-document': { admin: true },
  'import-training-documents': { admin: true },
  'import-loto': { admin: true },
  'import-project-documents': { admin: true },
  'compress-files': { admin: true },
  'support-tickets': { admin: true },
  'training-results': { admin: true },
  schedule: { admin: true },
  'role-permissions': { admin: true },
  roles: { admin: true },
}

// The route meta for one of them: the router's admin gate.
export function adminPageMeta(name) {
  if (!ADMIN_PAGES[name]) throw new Error(`no admin page named ${name}`)
  return { authRequired: true, adminRequired: true }
}

// Whether someone may open the page, given the auth module's `isAdmin` (ADMIN
// or DEVELOPER). `can` is still taken, so callers need not change, and is not
// consulted: no permission opens an admin page. Always a boolean.
export function mayOpenAdminPage(name, can, isAdmin) {
  return Boolean(ADMIN_PAGES[name]) && Boolean(isAdmin)
}

// Whether someone may open the admin area at all: admins and developers.
export function mayOpenAdminArea(can, isAdmin) {
  return Boolean(isAdmin)
}
